export interface TooltipViewportPosition {
  x: number;
  y: number;
  text?: string;
  position: string;
}

export enum TooltipPosition {
  top = 'top',
  bottom = 'bottom',
  bottomRight = 'bottomRight',
  bottomLeft = 'bottomLeft',
  topRight = 'topRight',
  topLeft = 'topLeft'
}
